/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".vs-breadcrumb[_ngcontent-%COMP%]{float:left;width:100%;padding:0}.vs-breadcrumb[_ngcontent-%COMP%]   .breadcrumb[_ngcontent-%COMP%]{padding:0 10px;line-height:30px;margin:10px 10px 0 7px}.vs-breadcrumb[_ngcontent-%COMP%]   .breadcrumb[_ngcontent-%COMP%]   .breadcrumb-item[_ngcontent-%COMP%]{float:left;list-style:none;padding-right:0}.vs-breadcrumb[_ngcontent-%COMP%]   .breadcrumb[_ngcontent-%COMP%]   .breadcrumb-item[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{margin-left:5px}"];
export { styles as styles };
